import { createSvgIcon } from '@material-ui/core';

export const WipIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.85 22.373L22.35 17.8673L18.6 14.1126L16.2 16.5156L14.1 14.413L16.5 12.01L12.75 8.30538L8.25 12.811L17.85 22.373ZM35.15 39.7947L39.65 35.239L35.9 31.4844L33.5 33.8874L31.4 31.7847L33.8 29.3817L30.1 25.6771L25.6 30.1827L35.15 39.7947ZM30.8 13.7622L34.3 17.2666L39 12.5607L35.5 9.05632L30.8 13.7622ZM13.8 42.0476H6V34.2378L15.7 24.5257L4 12.811L12.7 4L24.5 15.7647L33.4 6.85357C33.7 6.55319 34.0333 6.33625 34.4 6.20275C34.7667 6.06925 35.1333 6.0025 35.5 6.0025C35.8667 6.0025 36.2333 6.06925 36.6 6.20275C36.9667 6.33625 37.3 6.55319 37.6 6.85357L41.15 10.408C41.45 10.7084 41.6667 11.0421 41.8 11.4093C41.9333 11.7764 42 12.1435 42 12.5106C42 12.8778 41.9333 13.2449 41.8 13.612C41.6667 13.9791 41.45 14.3129 41.15 14.6133L32.25 23.5244L44 35.2891L35.25 44L23.55 32.2854L13.8 42.0476Z"
      fill="currentColor"
    />
  </svg>,
  'WipIcon',
);
